import { updateSubAccountAlert } from "./API";

const UpdateSubAccountAlert = async (
    alertId,
    subAccountName,
    hashrateThreshold,
    activeWorkersThreshold,
    emailList,
    accessToken
) => {
    try {
        const response = await updateSubAccountAlert(
            alertId,
            subAccountName,
            hashrateThreshold,
            activeWorkersThreshold,
            emailList,
            accessToken
        );
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, data: error.response.data.message };
    }
};

export default UpdateSubAccountAlert;
